<template>
  <div class="simple" id="simple">
    <my-header @update="goHead" />
    <!-- 标题关于我们 -->
    <div class="pre">
      <div class="allTitle">
        <!-- <span>{{name}}</span> -->
		<span>{{catalogName}}</span>
      </div>
    </div>

    <div class="mainBox clear">
      <!-- 导航 -->
      <div class="simpleLeft left">
        <div class="simpleNone" @click="showMenu = !showMenu">
          <b-icon-eye />&nbsp; &nbsp; &nbsp; 隐藏列表
        </div>
        <div class="simpleDisplay" v-if="showMenu">
          <div class="simpleTree clear">
            <span class="left">分类目录</span>
            <span class="simpleDown right"> <b-icon-chevron-down /></span>
          </div>

          <tree />
          <!-- <tree @update="updateParams" /> -->
        </div>
      </div>

      <!-- 右边盒子 -->
      <div class="simpleRight left">
        <div class="simpleDetail">
          <b-container>
            <b-row>
              <b-col
                cols="6"
                xs="6"
                sm="4"
                md="4"
                xl="4"
                lg="4"
                v-for="(current, i) in dataList"
              >
                <div
                  class="toDiv"
                  @click="toView('simpleDetail', current.id, current.name)"
                >
                  <img :src="current.imgPath3" />
                  <div class="striping">
                    <p class="p1">{{ current.title }}</p>
                    <p class="p2">{{ current.name }}</p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>

        <!-- 	<div class="load clear">
					<span></span>
					<span></span>
					<span></span>
				</div> -->
      </div>
    </div>

    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";
import tree from "@/views/tree.vue";

export default {
  components: {
    myHeader,
    myFooter,
    tree
  },

  data() {
    return {
      showMenu: true,
      parentId: this.$route.query.parentId,
      catalogId: this.$route.query.catalogId,
      name: this.$route.query.name,
      catalogName: this.$route.query.catalogName,
      dataList: [],
	  type:this.$route.query.type
    };
  },

  methods: {
    goHead(param) {
      this.catalogName = param.catalogName;
      this.catalogId = param.catalogId;
	  this.type = param.type;
	  debugger
      this.getProductList();
    },
    /**
     * @param {Object} url 页面路径
     * @param {Object} id 产品ID
     */
    toView(url, id, name) {
      let that = this;
      that.$router.push({
        name: url,
        query: {
          id: id,
          catalogName: that.catalogName,
          catalogId: that.catalogId,
          name: name
        }
      });
    },
    getProductList() {
      let that = this;
	  console.log(that.type)
      that.$axios
        .get(
          that.$global.baseURL +
            "/web/productList/getProductDataByCatalogId.form",
          {
            params: {
              catalogId: that.catalogId,
              catalogName: that.type == "1" ? "" : that.catalogName,
              parentId: that.parentId,
              name: that.name
            }
          }
        )
        .then(res => {
          if (res.data.jsonArray == "error") {
            uni.showModal({
              title: res.data.errorInfo,
              showCancel: false
            });
          } else {
            that.dataList = res.data.dataList;
          }
        });
    }
  },
  mounted() {
    if (this.$route.query.go) {
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }
    this.getProductList();
  },
  watch: {
    // 利用watch方法检测路由变化：
    $route: function(to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      this.catalogId = to.query.catalogId;
      this.catalogName = to.query.catalogName;
      this.name = to.query.name;
      this.parentId = to.query.parentId;
      this.getProductList();
    }
  }
};
</script>

<style>
.footerNav >>> .footer1 {
  margin-top: 60px;
}

/*最外层 */
.simple .pre {
  width: 100%;
}

.simple .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  letter-spacing: 10px;
  font-weight: lighter;
  font-family: "microsoft yahei";
  padding: 50px 0;
  border-bottom: 1px solid #c4c4c4;
}

.simple .mainBox {
  margin-bottom: 90px;
}

.simple .mainBox .simpleLeft {
  width: 180px;
  margin: 30px 0px 0px 80px;
}

.simple .mainBox .simpleLeft .simpleNone {
  font-size: 14px;
  color: #595757;
  padding-bottom: 20px;
  /* 
		border-bottom: 1px solid #c4c4c4; */
}

.simple .mainBox .simpleLeft .simpleTree {
  padding: 20px 0;
  font-size: 16px;
  color: #595757;
  border-top: 1px solid #c4c4c4;
}

.simple .mainBox .simpleLeft .tac {
  width: 100%;
}

.simple .mainBox .simpleLeft .tac .el-submenu {
  margin-top: -15px;
}

.simple .mainBox .simpleLeft .tac .el-submenu .el-submenu__title i {
  display: none;
}

.simple .mainBox .simpleLeft .tac .el-menu {
  border-right: none;
  margin-left: -18px;
}

.simple .mainBox .simpleLeft .tac .el-submenu .el-menu-item:nth-child(1) {
  margin-top: -20px;
}

.simple .mainBox .simpleLeft .tac .el-submenu .el-menu-item:nth-child(4) {
  margin-bottom: 10px;
}

.simple .mainBox .simpleLeft .tac .el-submenu .el-menu-item {
  height: 35px;
}

.simple
  .mainBox
  .simpleLeft
  .tac
  .el-menu
  .el-menu-item-group
  .el-menu-item-group__title {
  padding: 0;
}

.el-menu-item-group {
  margin-left: 10px;
}

.el-submenu__title:hover {
  background-color: transparent;
  color: #ccb356;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: transparent;
  color: #ccb356;
}

.simple .mainBox .simpleRight {
  width: -moz-calc(100% - 260px);
  width: -webkit-calc(100% - 260px);
  width: calc(100% - 260px);
}

.simple .mainBox .simpleRight .simpleDetail {
  /* width: 90%;
		margin: 0 auto; */
  width: 86%;
  margin: 0 auto;
  margin-top: 38px;
  margin-bottom: 20px;
}

.simple .mainBox .simpleRight .simpleDetail .toDiv {
  cursor: pointer;
}

.simple .mainBox .simpleRight .simpleDetail img {
  width: 100%;
  margin-bottom: 20px;
}

.simple .mainBox .simpleRight .simpleDetail .striping {
  border-top: 1px solid #c4c4c4;
  width: 70%;
  margin-top: 10px;
  margin-bottom: 50px;
  margin-left: 15%;
}

.simple .mainBox .simpleRight .simpleDetail .striping p {
  text-align: center;
  color: #595757;
}

.simple .mainBox .simpleRight .simpleDetail .striping .p1 {
  font-size: 12px;
  margin-top: 18px;
  letter-spacing: 0.3px;
}

.simple .mainBox .simpleRight .simpleDetail .striping .p2 {
  font-size: 20px;
  margin-top: -10px;
  margin-bottom: 30px;
}

/* .load {
		width: 20%;
		margin: 0 auto;
		margin-top: 40px;
		margin-bottom: 40px;
	}

	.load span {
		float: left;
		display: block;
		margin-left: 5px;
		width: 13px;
		height: 13px;
		background-color: #595757;
	} */

/* 媒体查询 */
@media screen and (max-width: 850px) {
  .mainBox .simpleLeft {
    display: none;
  }

  .simple .mainBox .simpleRight {
    width: calc(100% - 0px);
  }
}
</style>
